import assetPath from '/app/packages/lebenslauf/articles/src/assets/auslandsaufenthalt-im-lebenslauf-wie-du-deine-internationale-erfahrung-optimal-p.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')